// CustomModal.js
import { useAtom } from "jotai";
import React from "react";
import Modal from "react-modal";
import { categoriesAtom, currentGameAtom, userIsLoggedInAtom } from "../state/games";
import { getGameIframe, getGameIframeFromUrl } from "../helpers/helpers";
import { useLocation, useNavigate } from "react-router-dom";
import Icon from "./Icon";
import { SiteLogoIcon, CloseIcon } from "./Icons";
import { Button } from "@mui/material";
import { routes } from "../router/Routes";
import _ from "lodash";
const GameModal = () => {
    const [currentGame] = useAtom(currentGameAtom);
    const [userIsLoggedIn] = useAtom(userIsLoggedInAtom);
    const navigate = useNavigate();
    const location = useLocation();
    const [categories] = useAtom(categoriesAtom);
    // Accessing search params from location object
    const searchParams = new URLSearchParams(location.search);

    // Getting a specific search parameter value
    const for_fun = searchParams.get("for_fun");

    const closeModal = () => {
        if (currentGame) {
            const category = _.find(categories, { id: currentGame.cs?.at(0) });
            category ? navigate(`${routes.pages.games}/${category.slug}`) : navigate(routes.root);
        } else {
            navigate(routes.root);
        }
    };

    const gameIframe = currentGame
        ? getGameIframe(currentGame, userIsLoggedIn, for_fun === "true")
        : getGameIframeFromUrl(location.search, userIsLoggedIn);
    const customStyles = {
        overlay: {
            zIndex: 2147483647,
            background: "#0b1222",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: 0,
        },
        content: {
            background: "#0b1222",
            border: 0,
            borderRadius: 0,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: 0,
            overflow: "initial",
        },
    };
    return (
        <Modal
            isOpen={true}
            onRequestClose={closeModal}
            contentLabel="Modal"
            ariaHideApp={false}
            shouldCloseOnOverlayClick={true}
            style={customStyles}
        >
            <div className="gameloader-wrapper">
                <div className="panel">
                    <Icon cssclass="logo" icon={SiteLogoIcon}></Icon>
                    <Button onClick={() => closeModal()}>
                        <Icon icon={CloseIcon} />
                    </Button>
                </div>
                <div className="iframe-wrapper">
                    <iframe id="gameloader" src={gameIframe} width="100%"></iframe>
                </div>
            </div>
        </Modal>
    );
};

export default GameModal;
